import React, { useEffect, useRef, useState } from 'react';
import { FaUser } from 'react-icons/fa';
import { useAuth } from '../AuthContext';
import { loadConsultationPhoto, photoSession } from '../services/consultationPhotos';

export default function ConsultationPhoto({ row, scope, className }) {
  const { user } = useAuth();
  const session = photoSession(user);
  const revision = row.updatedAt || '';
  const [source, setSource] = useState(row.photoUrl || '');
  const target = useRef(null);
  useEffect(() => {
    let mounted = true;
    setSource(row.photoUrl || '');
    if (row.photoUrl || !row.id || !user) return () => { mounted = false; };
    const load = () => loadConsultationPhoto({ scope, id: row.id, revision, session, isVisible: () => mounted })
      .then((value) => { if (mounted) setSource(value || ''); })
      .catch(() => { /* Keep the standard avatar when a photo is absent or unavailable. */ });
    if (typeof IntersectionObserver === 'undefined') {
      load();
      return () => { mounted = false; };
    }
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) { observer.disconnect(); load(); }
    }, { rootMargin: '40px' });
    observer.observe(target.current);
    return () => { mounted = false; observer.disconnect(); };
  }, [row.id, row.photoUrl, revision, scope, session, user]);
  return <span ref={target} className={className} role="img" aria-label={`Foto de ${row.fullName || row.socialName || 'cadastro'}`}>
    {source && <img src={source} alt="" loading="lazy" decoding="async" width="38" height="38" onError={() => setSource('')} />}
    <FaUser aria-hidden="true" />
  </span>;
}
